import useAppModal from '../../../../hooks/useAppModal';
import AdjustmentModal from './AdjustmentModal';
import { AdjustmentModalParams } from './AdjustmentModal.types';

const adjustmentModalId = 'adjustment-modal';

const useOpenAdjustmentModal = () => {
  const { openModal } = useAppModal();

  // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const openAdjustmentModal = (params) => {
    openModal({
      customContent: (
        <AdjustmentModal modalId={adjustmentModalId} params={params} />
      ),
      id: adjustmentModalId,
      size: 'lg',
    });
  };

  return {
    createAdjustmentModal: (params: AdjustmentModalParams) => {
      openAdjustmentModal(params);
    },
  };
};

export default useOpenAdjustmentModal;
